import { render, staticRenderFns } from "./LolEnd.vue?vue&type=template&id=fc605080&"
import script from "./LolEnd.vue?vue&type=script&lang=js&"
export * from "./LolEnd.vue?vue&type=script&lang=js&"
import style0 from "./LolEnd.vue?vue&type=style&index=0&id=fc605080&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports